'use client'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import {
  transformConversationResponse,
  createItemConversationThread,
  createInquiryNew,
  ConversationInitiatorType,
  transformNewConversationResponse,
} from '@marketplace-web/messaging/conversation-messaging-data'

export const useCreateConversation = () => {
  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  const {
    fetch: createItemConversation,
    transformedData: conversationData,
    error: createItemConversationThreadError,
  } = useFetch(createItemConversationThread, response =>
    transformConversationResponse(response.conversation),
  )

  const {
    fetch: createInquiry,
    transformedData: inquiryData,
    error: createInquiryError,
  } = useFetch(createInquiryNew, response => transformNewConversationResponse(response))

  const createConversation = ({
    itemId,
    receiverId,
    initiator,
  }: {
    itemId: string | number
    receiverId: string
    initiator: ConversationInitiatorType
  }) => {
    if (isWebMessagingSvcFSEnabled) {
      createInquiry({
        itemIds: [itemId.toString()],
        receiverId,
      })

      return
    }

    createItemConversation({
      itemId: itemId.toString(),
      receiverId,
      initiator,
    })
  }

  const conversation = isWebMessagingSvcFSEnabled ? inquiryData : conversationData
  const error = isWebMessagingSvcFSEnabled ? createInquiryError : createItemConversationThreadError

  return { createConversation, conversation, error }
}

export default useCreateConversation
